import { cx } from 'cva'
import type { FC, PropsWithChildren } from 'react'

export type CorridorProps = {
	as?: 'div' | 'section'
	className?: string
}

export const Corridor: FC<PropsWithChildren<CorridorProps>> = ({
	as: Tag = 'div',
	className,
	children,
}) => {
	return <Tag className={cx('mx-auto w-full max-w-390 px-margin', className)}>{children}</Tag>
}
